import PrinterCard from "./printers/PrinterCard";

const PrintersSection = ({ printers,categories, onAddPrinter, onChangePrinter, onRemovePrinter }) => {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
      <div className="flex items-center gap-2 pb-4 border-b border-gray-100 mb-4">
        <div className="w-7 h-7 rounded-lg bg-black flex items-center justify-center text-white flex-shrink-0">
          <span className="text-xs font-semibold">2</span>
        </div>
        <div className="flex-1">
          <h2 className="text-sm font-semibold text-gray-900">Printers</h2>
          <p className="text-xs text-gray-500">
            Add Customer / Kitchen printers and enable or disable them anytime.
          </p>
        </div>
        <button
          type="button"
          onClick={onAddPrinter}
          className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-xl text-xs font-semibold active:scale-[0.98] transition-all duration-200"
        >
          + Add Printer
        </button>
      </div>

      {printers.length === 0 ? (
        <div className="rounded-2xl border-2 border-dashed border-gray-200 bg-gray-50 p-8 text-center">
          <p className="text-sm font-semibold text-gray-700">No printers added</p>
          <p className="text-xs text-gray-500 mt-1">
            Click <span className="font-semibold">Add Printer</span> to create one.
          </p>
        </div>
      ) : (
        <div className="space-y-4">
          {printers.map((p, idx) => (
            <PrinterCard
              key={p.id || p._id?.$oid || p._localId || idx}
              printer={p}
              index={idx}
              categories={categories}
              onChange={onChangePrinter}
              onRemove={onRemovePrinter}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default PrintersSection;

